/**
=========================================================

* Tazi Rides Ltd has developed this dashboard based on a further configured version of the original template.
* Website: https://www.tazirides.co.uk
* All rights reserved.

=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @material-ui core components
import React, { useContext } from 'react'

import { TextField } from '@mui/material'
import Card from '@mui/material/Card'

// Material Dashboard 2 PRO React TS components
import MDAvatar from 'components/MDAvatar'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import { useAuth } from 'context/auth'
import { FormContext } from 'layouts/business-account/constants'
import { BusinessAccountForm } from 'layouts/business-account/types'

function Notes() {
	const { user } = useAuth()
	const formContext = useContext(FormContext)

	const { localForm, setLocalForm, setFormEdited } = formContext

	const sectionDisabled = user.data.role === 'VIEWER'

	const handleFormUpdate = (value: string, field: keyof BusinessAccountForm['notes']) => {
		setLocalForm(prev => ({
			...prev,
			notes: {
				...prev.notes,
				[field]: value,
			},
		}))
		setFormEdited(true)
	}
	return (
		<Card id="notes">
			<MDBox display={'flex'} flexDirection={'row'} gap={2} p={3}>
				<MDAvatar bgColor="primary" size="xs">
					2
				</MDAvatar>
				<MDTypography variant="h5" fontWeight="medium">
					Notes
				</MDTypography>
			</MDBox>
			<MDBox component="form" pb={3} px={3}>
				<TextField
					label="Additional Notes"
					multiline
					disabled={sectionDisabled}
					rows={5} // Adjust number of rows for the size of the textarea
					variant="outlined"
					value={localForm.notes.content}
					placeholder="Please provide any additional notes or comments."
					InputLabelProps={{ shrink: true }}
					fullWidth
					onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
						handleFormUpdate(e.target.value, 'content')
					}}
				/>
			</MDBox>
		</Card>
	)
}

export default Notes
